
import styles from './ServerSettingsView.module.css';
import React from 'react';
import Button from '../components/Button';

import SpotifyPlaylist from '../components/SpotifyPlaylist';
import {
  Link
} from "react-router-dom";

class ServerSettingsView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {server: "pepega"};

    this.createPlaylist = this.createPlaylist.bind(this);
    this.unlinkPlaylist = this.unlinkPlaylist.bind(this);
    this.updatePlaylist = this.updatePlaylist.bind(this);
    this.updatePlaylistMetadata = this.updatePlaylistMetadata.bind(this);
  }

  fetchGuildData() {
    console.log("fetchGuildData was called");
    const requestOptions = {
      method: 'GET',
      headers: 
      {
        "authorization": localStorage.getItem("user_token")
      }
    };

    fetch(process.env.REACT_APP_INTERNAL_API_DOMAIN + 'guild/' + this.props.guildid, requestOptions)
    .then(response => {
      if(response.status === 401 || response.status === 403)
      {
        console.log("Forcing the user to re-authorize:");
        window.location.href = `https://discord.com/oauth2/authorize?client_id=611247115829510165&redirect_uri=${process.env.REACT_APP_DISCORD_REDIRECTURI}&response_type=code&scope=identify%20guilds`; 
        return null;
      }
      
      console.log(response);
      return response;
    })
    .then(response => response.json())
    .then(data => {

      console.log("FETCHGUILDDATA:");
      this.setState({server: data, amount: data.amount, frequency: data.frequency});
      console.log(data);

      this.forceUpdate();
      this.render();
    });
  }
  
  componentDidMount(){
    this.fetchGuildData();
  }

  updatePlaylist()
  {
    var postbody = {
      "frequency": document.getElementById("frequency").value,
      "amount": document.getElementById("amount").value
    }

    const requestOptions = {
      method: 'PUT',
      headers: 
      {
        "Content-Type": "application/json",
        "authorization": localStorage.getItem("user_token")
      },
      body: JSON.stringify(postbody)
    };

    fetch(process.env.REACT_APP_INTERNAL_API_DOMAIN + 'guild/' + this.props.guildid + '', requestOptions)
    .then(response => {
      if(response.status === 401 || response.status === 403)
      {
        console.log("Forcing the user to re-authorize:");
        window.location.href = `https://discord.com/oauth2/authorize?client_id=611247115829510165&redirect_uri=${process.env.REACT_APP_DISCORD_REDIRECTURI}&response_type=code&scope=identify%20guilds`; 
        return null;
      }
      console.log(response);
      return response;
    })
    .then(response => response.json())
    .then(data => {

      console.log("RECIEVED THESE DETAILS");
      console.log(data);

      this.fetchGuildData();
      this.forceUpdate();
      this.render();

      this.updatePlaylistMetadata();
    });
  }



  createPlaylist()
  {
    var postbody = {
      "frequency": document.getElementById("frequency").value,
      "amount": document.getElementById("amount").value
    }

    const requestOptions = {
      method: 'POST',
      headers: 
      {
        "Content-Type": "application/json",
        "authorization": localStorage.getItem("user_token")
      },
      body: JSON.stringify(postbody)
    };

    fetch(process.env.REACT_APP_INTERNAL_API_DOMAIN + 'guild/' + this.props.guildid + '/playlist', requestOptions)
    .then(response => {
      response.json().then(data => {
        if(response.status === 401)
        {
          console.log("Forcing the user to re-authorize:");
          window.location.href = `https://discord.com/oauth2/authorize?client_id=611247115829510165&redirect_uri=${process.env.REACT_APP_DISCORD_REDIRECTURI}&response_type=code&scope=identify%20guilds`; 
          return null;
        }
        else if(response.status === 403)
        {
          alert(data.status);
          return null;
        }

        this.setState({server: data, amount: data.amount, frequency: data.frequency});
        this.forceUpdate();
        this.render();
      })


    })
  }

  unlinkPlaylist()
  {

    const requestOptions = {
      method: 'DELETE',
      headers: 
      {
        "authorization": localStorage.getItem("user_token")
      }
    };

    fetch(process.env.REACT_APP_INTERNAL_API_DOMAIN + 'guild/' + this.props.guildid + '/playlist', requestOptions)
    .then(response => {
      if(response.status === 401 || response.status === 403)
      {
        console.log("Forcing the user to re-authorize:");
        window.location.href = `https://discord.com/oauth2/authorize?client_id=611247115829510165&redirect_uri=${process.env.REACT_APP_DISCORD_REDIRECTURI}&response_type=code&scope=identify%20guilds`; 
        return null;
      }
      console.log(response);
      return response;
    })
    .then(response => response.json())
    .then(data => {

      console.log("RECIEVED THESE DETAILS");
      console.log(data);

      this.fetchGuildData();
      this.forceUpdate();
      this.render();
    });
  }

  updatePlaylistMetadata()
  {

    const requestOptions = {
      method: 'PUT',
      headers: 
      {
        "authorization": localStorage.getItem("user_token")
      }
    };

    fetch(process.env.REACT_APP_INTERNAL_API_DOMAIN + 'guild/' + this.props.guildid + '/playlist', requestOptions)
    .then(response => {
      if(response.status === 401 || response.status === 403)
      {
        console.log("Forcing the user to re-authorize:");
        window.location.href = `https://discord.com/oauth2/authorize?client_id=611247115829510165&redirect_uri=${process.env.REACT_APP_DISCORD_REDIRECTURI}&response_type=code&scope=identify%20guilds`; 
        return null;
      }
      console.log(response);
      return response;
    })
    .then(response => response.json())
    .then(data => {

      console.log("RECIEVED THESE DETAILS");
      console.log(data);

      this.fetchGuildData();
      this.forceUpdate();
      this.render();
    });
  }


  render(){
    console.log("CURRENT STATE:");
    console.log(this.state);
    console.log("CURRENT PROPS:");
    console.log(this.props);

    var botinvitelink = `https://discord.com/oauth2/authorize?client_id=611247115829510165&guild_id=${this.props.guildid}&scope=bot%20applications.commands`;
    



    return <div>
      <h1>Server Settings for {this.state.server.name}</h1>
      <h2>Uses Spotify account of this user: {this.state.server.userid}</h2>

      <div class={styles.serversettings}>
        <div class={styles.singleServerSetting}>
          <span>Frequency of updates:</span>
          <select name="frequency" id="frequency" value={this.state.frequency} onChange={(e) => {this.setState({frequency: e.target.value})}}>
            <option value="daily">Daily</option>
            <option value="weekly">Weekly</option>
            <option value="monthly">Monthly</option>
          </select>
        </div>

        <div class={styles.singleServerSetting}>
          <span>Maximum amount of tracks within playlist:</span>
          <select name="amount" id="amount" value={this.state.amount} onChange={(e) => {this.setState({amount: e.target.value})}}>
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </div>
      </div>


      <div class={styles.buttons}>
        {this.state.server.playlistid != null ? <Button primary onClick={this.updatePlaylist}>Update Playlist</Button> : <Button primary onClick={this.createPlaylist}>Create Playlist</Button> }
        
        <a target="_blank" href={botinvitelink} rel="noreferrer">
          <Button primary>Invite Bot</Button>
        </a>

        {this.state.server.playlistid != null ? <Button dangerous onClick={this.unlinkPlaylist}>Unlink Playlist</Button> : null }
      </div>


      { this.state.server.playlistid != null ? <SpotifyPlaylist playlistid={this.state.server.playlistid} class={styles.spotifyplaylist}/> : null}

      <h2>How to set up Music Server Charts:</h2>
      <p>1) Authorize your Spotify account in your <Link to="/dashboard/account" className={styles.headeritem}>Account Settings</Link></p>
      <p>2) Invite the bot to your server</p>
      <p>3) Select your preferred settings and create the playlist</p>
      
      <h2>Please note:</h2>
      <p>The playlist will be empty initially, but will be filled with data once the next update arrives.<br></br>All updates only occur at midnight CEST. Weekly updates only occur every monday, monthly updates only occur every first of the month.</p>


    </div>
  }





}





export default ServerSettingsView;
